module.exports = __webpack_public_path__ + "static/media/banner.e211fed8.svg";